import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { createSafeContext } from '@coveord/plasma-mantine';
var _createSafeContext = _sliced_to_array(createSafeContext('TopBar component was not found in tree'), 2);
export var TopBarProvider = _createSafeContext[0], useTopBarContext = _createSafeContext[1];

//# sourceMappingURL=TopBarContext.js.map